<template>
    <div class="bg-white text-center mt-8 mb-2">
      <img src="../../assets/img/icon/namaste.png" width="280">
      <p class="pt-3 heading-4 text-22 mb-1">{{ title }}</p>
      <p class="body-2 mb-4 w-75 mx-auto">{{ message }}</p>
      <div class="w-100 text-center">
        <button v-if="btn_primary != ''" class="btn bg-green text-14 body-3-1 text-white px-3" @click="primaryClick()">{{ btn_primary }}</button>
        <button v-if="btn_secondary != ''" class="btn bg-orange text-14 body-3-1 text-white px-3" @click="secondaryClick()">{{ btn_secondary }}</button>
      </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        },
        btn_primary: {
            type: String,
            default: ''
        },
        btn_secondary: {
            type: String,
            default: ''
        }
    },
    methods: {
        primaryClick(){
            this.$emit('primary');
        },
        secondaryClick(){
            this.$emit('secondary');
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/general/BlankPage.vue